import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { languageOptions } from "@/i18n";
import Logo from "@/components/Logo";
import MbsLogo from "@/components/MbsLogo";
import { ChevronLeft } from "lucide-react";

export default function LanguageGateway() {
  const navigate = useNavigate();
  const { lang, setLang, t } = useLang();

  const choose = (code) => {
    setLang(code);
    navigate("/home");
  };

  const goBack = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate("/home");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 py-10 sm:py-16 bg-background">
      <div className="w-full max-w-5xl">
        <button
          onClick={goBack}
          data-testid="language-back-button"
          className="mb-8 min-h-[44px] px-4 py-2 border border-[#262626] hover:border-white font-mono-label text-xs inline-flex items-center gap-2 transition-colors"
        >
          <ChevronLeft size={16} /> {t("back")}
        </button>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <div className="mb-10">
            <div className="mb-8">
              <MbsLogo />
              <p className="shimmer-text mt-4 font-heading font-bold text-base sm:text-lg" data-testid="mbs-tagline">
                &ldquo;Over 20 years of industry service, presents your full service transportation app&rdquo;
              </p>
            </div>
            <Logo size="lg" />
            <div className="font-heading font-black text-lg mt-5">Welcome · Bienvenido · 欢迎 · स्वागत है</div>
          </div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl leading-none mb-4" data-testid="language-gateway-title">
            {t("chooseLanguage")}
          </h1>
          <p className="text-base text-muted-foreground max-w-xl mb-12">
            Pick a language to continue. You can change it any time from the dashboard.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 brutal-border">
            {languageOptions.map((opt, i) => (
              <motion.button
                key={opt.code}
                data-testid={`lang-option-${opt.code}`}
                onClick={() => choose(opt.code)}
                className={`text-left p-5 sm:p-8 border-r border-b border-[#262626] bg-[#141414] hover:bg-[#1a1a1a] transition-colors duration-200 ${lang === opt.code ? "ring-2 ring-[#0055FF] ring-inset" : ""}`}
                whileHover={{ x: 4 }}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.05 * i }}
              >
                <div className="font-mono-label text-xs text-muted-foreground mb-2">{opt.code.toUpperCase()}</div>
                <div className="font-heading font-black text-2xl mb-1">{opt.native}</div>
                <div className="text-sm text-muted-foreground">{opt.label}</div>
              </motion.button>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
